import { render, staticRenderFns } from "./taskToComplete.vue?vue&type=template&id=15a1a6cc&scoped=true&"
import script from "./taskToComplete.vue?vue&type=script&lang=js&"
export * from "./taskToComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1a6cc",
  null
  
)

export default component.exports